/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .controller('EmailLinkController', [
        '$scope',
        '$modalInstance',
        'element',
        'RecipientType',
        'operationComplete',
        'template',
        'NodeShareLink',
        function (
            $scope,
            $modalInstance,
            element,
            RecipientType,
            operationComplete,
            template,
            NodeShareLink
        ) {
            $scope.modal = $modalInstance.options;
            $scope.modal.footerTemplate = template('nodes/_invitation_modal_footer');
            $scope.element = element;
            $scope.invitation = NodeShareLink.buildEmailLinkFromFile(element);
            $scope.link = $scope.invitation;
            $scope.cancel = $scope.close = () => $modalInstance.dismiss('cancel');
            $scope.disableSubmit = () => {
                return ($scope.invitation.never_expire !== true && !$scope.invitation.ttl) ||
                    (!$scope.recipients || $scope.recipients.length <= 0) ||
                    ($scope.link.isPublicWithPassword() && !$scope.link.password);
            }
            $scope.onRecipientsUpdate = (recipients) => $scope.recipients = recipients;
            $scope.recipients = [];
            $scope.ok = () => {
                const invitation = angular.copy($scope.invitation);
                $scope.modal.loading = true;

                invitation.recipients = $scope.recipients.map((recipient) => {
                    const recipientType = recipient.type || RecipientType.EMAIL;

                    return {
                        type: recipientType,
                        ...(recipientType === RecipientType.GROUP ? {recipient_entity_uuid: recipient.uuid} : {}),
                        ...(recipientType === RecipientType.EMAIL ? {email: recipient} : {})
                    }
                });

                const request = invitation.single_use ? NodeShareLink.saveAll : NodeShareLink.save;

                request(invitation).$promise
                    .then(() => {
                        operationComplete('node_share_links_email_link_request_success');
                        $modalInstance.close('reload_nodes');
                    })
                    .finally(() => $scope.modal.loading = false);
            }
        }]);
